<template>
  <g v-if="hasSize">
    <clipPath :id="idName.clipPath">
      <rect
        :x="size.graph.left"
        :y="size.graph.top"
        :height="size.graphH"
        :width="size.graphW"
      />
    </clipPath>

    <linearGradient :id="idName.gradient" x1="0" x2="0" y1="0" y2="1">
      <stop offset="50%" stop-color="#ffffff" stop-opacity="1"></stop>
      <stop offset="100%" stop-color="#ffffff" stop-opacity="0"></stop>
    </linearGradient>
    <mask :id="idName.gradientMask">
      <rect
        :x="size.graph.left"
        :y="size.graph.top"
        :height="size.graphH"
        :width="size.graphW"
        :fill="'url(#' + idName.gradient + ')'"
      />
    </mask>
  </g>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: false
    },
    size: {
      type: Object,
      required: true
    }
  },

  computed: {
    idName() {
      let clipPathId = 'clipPath';
      let gradientId = 'gradient';
      let gradientMaskId = 'gradientMask';
      if (this.id) {
        let variant = '--' + this.id;
        clipPathId += variant;
        gradientId += variant;
        gradientMaskId += variant;
      }
      return {
        clipPath: clipPathId,
        gradient: gradientId,
        gradientMask: gradientMaskId
      };
    },
    hasSize() {
      return this.size.canvasH && this.size.canvasW;
    }
  }
};
</script>
